module.exports = __webpack_public_path__ + "static/media/Bapuji.6b7ccdb2.png";